import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  content: PropTypes.string.isRequired,
};

export default function TrainerContent({ content }) {
  return (
    <div
      className="prose lg:prose-lg"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

TrainerContent.defaultProps = defaultProps;
TrainerContent.propTypes = propTypes;
